// @flow
import TextArea from './TextArea'
import { createFormGroup } from '@src/components/ui/FormGroup'

export default createFormGroup(TextArea)
